import { memo } from "react";
import { Group } from "contexts/GroupsContext/GroupsContext";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import Dialog from "components/DialogV2";
import DialogHeader from "components/DialogV2/DialogHeader";
import DialogTitle from "components/DialogV2/DialogTitle";
import DialogClose from "components/DialogV2/DialogClose";
import DialogContent from "components/DialogV2/DialogContent";
import DialogActions from "components/DialogV2/DialogActions";
import Button from "components/Button";
import ThemeProvider2024 from "components/MuiThemeProvider/ThemeProvider2024";

interface DeleteGroupDialogProps {
  group: Pick<Group, "id" | "name">;
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

function DeleteGroupDialog(props: DeleteGroupDialogProps) {
  const { open, onClose, group, onConfirm } = props;
  const { t } = useTranslation();

  return (
    <ThemeProvider2024>
      <Dialog open={open} onClose={onClose} width={450}>
        <DialogHeader>
          <DialogTitle>{t("group.all.delete_group_confirmation_header")}</DialogTitle>
          <DialogClose />
        </DialogHeader>
        <DialogContent>
          <Typography
            sx={{
              textAlign: "center",
              fontWeight: "fontWeightMedium",
              mb: 0.5,
            }}
          >
            {t("global.are_you_sure_to_delete_name", { name: group.name })}
          </Typography>
          <Typography
            variant="TextS"
            sx={{
              textAlign: "center",
            }}
          >
            {t("group.delete_group_confirmation_description")}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ flexDirection: "column", gap: 2, pt: 2 }}>
          <Button variant="danger" size="small" fullWidth onClick={onConfirm}>
            {t("group.delete_group_confirmation_button_text")}
          </Button>
          <Button variant="tertiary" size="small" fullWidth onClick={onClose}>
            {t("global.cancel_button_text")}
          </Button>
        </DialogActions>
      </Dialog>
    </ThemeProvider2024>
  );
}

export default memo(DeleteGroupDialog);
